import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";
import SearchParams from "../searchParams";

export const search = (api: API) => ({
  omni(
    query: OpenAPI.GET<"/search/omni">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/search/omni">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const params = new SearchParams(query);
    api.authenticatedRequest(
      "GET",
      `/search/omni${params.toSafeString()}`,
      null,
      success,
      fail,
    );
  },
  admins(
    term: string,
    success: (data: OpenAPI.GET<"/search/admins">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/search/admins?query=${term}`,
      null,
      success,
      fail,
    );
  },
  challengeOwner(
    challengeId: string,
    term: string,
    success: (
      data: OpenAPI.GET<"/search/challenges/{id}/owner">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/search/challenges/${challengeId}/owner?query=${term}`,
      null,
      success,
      fail,
    );
  },
  challengeAssessors(
    challengeId: string,
    term: string,
    success: (
      data: OpenAPI.GET<"/search/challenges/{id}/assessors">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/search/challenges/${challengeId}/assessors?query=${term}`,
      null,
      success,
      fail,
    );
  },
  ideaCollaborators(
    id: string,
    term: string,
    success: (
      data: OpenAPI.GET<"/search/ideas/{id}/collaborators/new">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/search/ideas/${id}/collaborators/new?query=${term}`,
      null,
      success,
      fail,
    );
  },
  groupMembers(
    id: string,
    params: OpenAPI.GET<"/search/groups/{id}/members/new">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/search/groups/{id}/members/new">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params).toSafeString();
    api.authenticatedRequest(
      "GET",
      `/search/groups/${id}/members/new${queryParams}`,
      null,
      success,
      fail,
    );
  },
  ideaBusinessProfileMembers(
    id: string,
    params: OpenAPI.GET<"/search/ideaBusinessProfile/{id}/members/new">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/search/ideaBusinessProfile/{id}/members/new">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params).toSafeString();
    api.authenticatedRequest(
      "GET",
      `/search/ideaBusinessProfile/${id}/members/new${queryParams}`,
      null,
      success,
      fail,
    );
  },
  messageRecipient(
    term: string,
    success: (
      data: OpenAPI.GET<"/search/messages/recipient">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/search/messages/recipient?query=${term}`,
      null,
      success,
      fail,
    );
  },
  getRecentSearches(
    success: (data: OpenAPI.GET<"/search/omni/recent">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("GET", "/search/omni/recent", null, success, fail);
  },
  recentSearch(
    searchData: OpenAPI.POST<"/search/omni/recent">["requestBody"],
    success: (data: OpenAPI.POST<"/search/omni/recent">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      "/search/omni/recent",
      searchData,
      success,
      fail,
    );
  },
  innovationIntelligenceListSharing(
    term: string,
    exclude: string,
    success: (
      data: OpenAPI.GET<"/search/innovationintelligence/lists/sharing">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/search/innovationintelligence/lists/sharing?query=${term}&exclude=${exclude}`,
      null,
      success,
      fail,
    );
  },
  google(
    query: string,
    page: number,
    limit: number,
    success: (data: OpenAPI.GET<"/search/google">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/search/google?query=${query}&page=${page}&limit=${limit}`,
      null,
      success,
      fail,
    );
  },
});
